<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div>
    <p-carousel [value]="items" [numVisible]="1" [numScroll]="1">
      <ng-template let-image pTemplate="item">
        <div
          class="text-center border border-surface-200 dark:border-surface-700">
          <div class="mb-4">
            <div class="relative mx-auto">
              @if (image?.value?.url) {
                <img
                  [src]="image?.value?.url"
                  class="w-full h-[250px] object-cover rounded-border" />
              }
            </div>
          </div>
          <div
            class="font-bold"
            [attr.style]="buildStyle('title', image.styles?.title)">
            {{ image?.value?.title }}
          </div>
          <div
            [attr.style]="buildStyle('description', image.styles?.description)" [innerHTML]="image?.value?.description | lineBreak">
          </div>
        </div>
      </ng-template>
    </p-carousel>
  </div>
</div>
